<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">

    <!--<div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.displayName }}</p>
    </div>-->

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" ref="vsDropdown">

      <div class="con-img ml-3">
        <feather-icon icon="UserIcon" class="p-3 inline-flex rounded-full text-white" :style="{background: `rgba(var(--vs-primary),1)`}"></feather-icon>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$refs.vsDropdown.$refs.dropdown.click(); $router.push('/profile')">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>
          
          <li
            v-if="$hasPermission('list:tenants')"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$refs.vsDropdown.$refs.dropdown.click(); $router.push('/tenants')">
            <feather-icon icon="UsersIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tenants</span>
          </li>

          <vs-divider class="m-1" />
          
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$refs.vsDropdown.$refs.dropdown.click(); logout();">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import auth0 from '@/auth0';
export default {
  data () {
    return {

    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    logout () {
      auth0.logout();
      //this.$router.push('/pages/login').catch(() => {})
    }
  }
}
</script>
